import { PanelItem } from '../panel-item.class'

export const getPanelSleeveCfn = (panelItem: PanelItem): string | null => {
	const group = panelItem.refMap.panelItemGroup ?? null;

	if (!group) {
		return null;
	}

	// this item IS a sleeve or jacket -- it doesn't have a sleeve itself
	if (panelItem.item.component.sleeveDepth !== null || panelItem.item.category?.isInsulatedJacket) {
		return null;
	}

	// only sleeve-compatible appliances are wrapped by a sleeve/jacket. Grills and side
	// burners are implicitly sleeve-compatible so any grill placed inside a sibling sleeve
	// or insulated jacket is hidden and only the wrapper renders. The C1CHCS asado is the
	// legacy C1SLV+C1CHCS pairing -- its catalog category is 'Smokers' (not Grills/Side
	// Burners) so it needs an explicit exemption here; same precedent as countertop-spacing.
	// front-only siblings like access doors / drawers live below the sleeve and must keep
	// their own dimensions/rendering -- consumers of panelItem.sleeve suppress drawing when
	// sleeve !== null, so resolving it for a non-wrapped sibling blanks its dim lines.
	if (
		!panelItem.item.component.sleeveCompatible
		&& !panelItem.item.category?.isGrillOrSideBurner
		&& panelItem.item.sku !== 'C1CHCS'
	) {
		return null;
	}

	const sleeve = group.items?.children.find((item) => (item.item.component.sleeveDepth !== null || item.item.category?.isInsulatedJacket) && item.item.sku);
	return sleeve?.item.component.id ?? null;
};
